import {IPaginationState} from 'plugins/modules/pagination/types';
import {createContext} from 'react';
import {PaginationUrlService} from 'plugins/modules/pagination/services/PaginationUrlService';

export interface IPaginationContext extends IPaginationState {
    urlService?: PaginationUrlService;
    onAccPageChange?: (num: number) => void;
}

export const PaginationContext = createContext<IPaginationContext>({
    count: 0,
    onPageClick: () => {},
    page: 0,
    size: 0,
    type: 'auto',
});
